import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
  Avatar,
  Card,
  CardContent,
  CardMedia,
  Link,
  ThemeProvider,
  createTheme,
  Paper,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { ApptContext, FacilitySchedule } from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import {
  formatphone,
  GetAvailableSlotsByLocation,
  removePreRegistration,
} from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import FacilitySlots from "./FacilitySlots";
import { Box } from "@mui/material";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  To display the available schedules of the Facility
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  7882   12/26/2023  SK  Book Appointment Flow isn't working in EDGE and SAFARI browser, Desktop and Smartphones - Patient Portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8722   11/06/2024  DK  PE workflows enhancements


const Styles = makeStyles((theme) => ({
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  topBarItem_Day: {
    color: "#A8ABAE",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: ".1em",
    whiteSpace: "normal",
    fontSize: "10px",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    //width: "70%",
    fontSize: "smaller",
    //height: "25px",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "2rem",
    },
  },
  paper: {
    height: "auto",
    width: "auto",
    alignContent: "center",
    display: "flex",
    justifyContent: "center",
    border: "none",
    boxShadow: "none",
  },
  scrollbar: {
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:vertical": {
      backgroundColor: "rgba(0,0,0,.5)",
    },
  },
}));

interface DaySlot {
  dateLabel: string;
  hiddenDateValue: string;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function FacilitySchedules() {
  const classes = Styles();
  const [weekSlots, setweekSlots] = useState<DaySlot[]>([]);
  const [dateCounter, setDateCounter] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [facilitySchedules, setFacilitySchedules] = useState<
    FacilitySchedule[]
  >([]);
  const [todayDate, setToday] = useState<boolean>(false);
  let tempdays: DaySlot[] = [];
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const { state, dispatch } = useContext(ApptContext);
  const [limited, setLimit] = useState<number>(7);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const styles = useStyles();
  const navigate = useNavigate();
  const [reload, setReload] = useState(0);
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      state.AppointmentDate = date;
      InsertPPLogs(
        "Changed the date to " + date.toDateString() + " in by location flow",
        window.location.href,
        userName,
        ""
      );
    }
  };
  const handleGoBack = async () => {
    InsertPPLogs(
      "Clicked on Go Back - Slots page by provider flow",
      window.location.href,
      userName,
      ""
    );
    await removePreRegistration(state.SlotDetails.id);
    navigate(-1);
  };
  const handleProceed = () => {
    navigate("/user/bookappointment/provider/slots");
  };
  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  function constructDates(dtCounter: number = dateCounter) {
    let limit: number = dtCounter + 1;
    tempdays = [];
    if (window.innerWidth < 800) {
      limit = dtCounter + 1;
      setLimit(1);
    } else {
      limit = dtCounter + 7;
      setLimit(7);
    }
    for (dtCounter; dtCounter < limit; dtCounter++) {
      let currentDate = new Date();
      if (
        selectedDate !== null &&
        selectedDate.toDateString() !== currentDate.toDateString()
      ) {
        currentDate = new Date(selectedDate);
      }
      let days = currentDate.getDate() + dtCounter;
      let value = new Date(currentDate.setDate(days));
      //FB 7882 - Begin
      let formattedcurrentDate = `${(value.getMonth() + 1).toString().padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}-${value.getFullYear()}`;
      tempdays.push({
        dateLabel: value.toString().substring(0, 10),
        hiddenDateValue:formattedcurrentDate,
      });
    }
    //FB 7882 - End
    setweekSlots(tempdays);
    setDateCounter(dtCounter);
    today();
  }

  function today() {
    let currentDate = new Date();
    let days = currentDate.getDate();
    let value = new Date(currentDate.setDate(days));
    let splittedDate = value.toLocaleDateString().split("/");
    if (
      `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}` ===
      tempdays[0].hiddenDateValue
    )
      setToday(true);
    else setToday(false);
  }

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    constructDates(0);
    today();
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    if (selectedDate !== null) {
      constructDates(0);
    }
  }, [selectedDate]);

  useEffect(() => {
    //FB 8722
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;//FB 8024
    let  customAppointmentAdmin = (sessionStorage.getItem("CustomAppointments"));//FB 8024
    if (weekSlots.length > 0) {
      setLoading(true);
      let temp: FacilitySchedule[] = [];
      setTimeout(() => {
        (async () => {
          temp = await GetAvailableSlotsByLocation(
            limited,
            weekSlots[0].hiddenDateValue,
            state.Facility.ID,
            0,//FB 8024
            Number(appt_type_n) //FB 8024
          );
          //FB 8024 - Begin
          if (customAppointmentAdmin == "true") {
            for (const facility of temp) {
              for (const slotsDate of facility.SlotsDate) {
                if (slotsDate.ApptTypeSlots.length > 1) {
                  slotsDate.Slots = slotsDate.ApptTypeSlots.slice();
                }
                else {
                  slotsDate.Slots = [""];
                }
              }
            }
            setFacilitySchedules(temp);
          }
          else {
            setFacilitySchedules(temp);
          }
          //FB 8024 - End
          setLoading(false);
        })();
      }, 1000);
    }
  }, [weekSlots]);

  useEffect(() => {
    if (state.SlotDetails.isslotexisting) {
      setReload(1);
    }
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card className={styles.slotspage_Card} style={{ boxShadow: "none" }}>
            <CardMedia
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "5%",
              }}
            >
              <Avatar
                //style={{ margin: 5 }}
                className={styles.slotspage_Avatar}
                src={"/Images/Locations/" + state.Facility.ID + ".jpg"}
              />
            </CardMedia>
            <CardContent>
              <Typography variant="h6">
                <b>{state.Facility.Name}</b>
              </Typography>
              <Typography style={{ fontSize: "medium" }}>
                {state.Facility.Address.includes("null")
                  ? ""
                  : state.Facility.Address}
              </Typography>
              {/* FB 4715 DK - Replaced number formatting with a function call */}
              <Typography style={{ fontSize: "medium" }}>
                {formatphone(state.Facility.Phone)}
              </Typography>
              <Typography
                style={{
                  display: state.Facility.Address.includes("null")
                    ? "none"
                    : "flex",
                }}
              >
                <Link
                  href={state.Facility.GOOGLE_MAPS_LINK}//FB 7413
                  //onClick={insertLogs}
                  target="_blank"
                >
                  View Map
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        style={{ display: window.innerWidth <= 768 ? "flex" : "none" }}
      >
        <Grid item xs={window.innerWidth === 768 ? 6 : 12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                id="dateByLocation"
                className={`${classes.datepickerroot} ${classes.topBarItem}`}
                fullWidth
                inputVariant="standard"
                orientation="portrait"
                value={selectedDate}
                label="Pick different date"
                onChange={(date) => handleDateChange(date)}
                format="MM/dd/yyyy"
                minDate={new Date()}
                initialFocusedDate={null}
                minDateMessage="Date should not be in past"
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)" }}
        direction="row"
        alignContent="center"
        justify={window.innerWidth > 768 ? "flex-end" : "center"}
      >
        <Grid
          item
          sm={3}
          md={3}
          style={{ display: window.innerWidth > 768 ? "flex" : "none" }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                id="differentDateByLocation"
                className={`${classes.datepickerroot} ${classes.topBarItem}`}
                fullWidth
                inputVariant="standard"
                orientation="landscape"
                value={selectedDate}
                label="Pick different date"
                onChange={(date) => handleDateChange(date)}
                format="MM/dd/yyyy"
                minDate={new Date()}
                initialFocusedDate={null}
                minDateMessage="Date should not be in past"
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={2} sm={1} md={1}>
          {todayDate === false ? (
            <Tooltip title="Previous">
              <IconButton
                aria-label="previous"
                onClick={() =>
                  constructDates(
                    limited === 7 ? dateCounter - 14 : dateCounter - 2
                  )
                }
              >
                <ArrowBack
                  className={styles.navigationArrows}
                  fontSize="large"
                />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )}
        </Grid>
        <Grid
          item
          xs={6}
          sm={7}
          md={7}
          style={{ display: "flex" }}
          direction="row"
          alignContent="space-around"
          justify="center"
        >
          {weekSlots.map((ele: DaySlot, index: number) => {
            return (
              <Grid key={index} item sm={2} md={2}>
                <Paper className={classes.paper}>
                  <span className={classes.topBarItem_Day}>
                    {ele.dateLabel.substring(0, 3)}
                  </span>
                </Paper>
                <Paper className={classes.paper}>
                  <span>{ele.dateLabel.substring(4, 10)}</span>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
        <Grid item xs={2} sm={1} md={1}>
          <Tooltip title="Next">
            <IconButton aria-label="next" onClick={() => constructDates()}>
              <ArrowForward
                className={styles.navigationArrows}
                fontSize="large"
              />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        style={{ display: "flex", minHeight: "40vh", marginTop: "15px" }}
        direction="row"
        alignContent="center"
        justify="center"
      >
        {loading ? (
          <Grid item xs={12} style={{ margin: "auto" }}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <CircularProgress />
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            className={classes.scrollbar}
            style={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            {facilitySchedules.length === 0 ? (
              <Grid item xs={12} style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <div className={classes.timeSlotItem}>
                    <Typography
                      variant="subtitle2"
                      style={{ textAlign: "center" }}
                    >
                      There are no online appointments available for this
                      location. Please call {formatphone(state.Facility.Phone)}{" "}
                      to book an appointment.
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
            {facilitySchedules.map((ele: FacilitySchedule, index: number) => {
              return (
                <FacilitySlots
                  FacilitySchedules={facilitySchedules}
                  Limited={limited}
                  Index={index}
                  FacilityId={state.Facility.ID}
                  FacilityName={state.Facility.Name}
                  isLoading={setLoading}
                />
              );
            })}
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={2}
        className={styles.flexend_Grid}
        style={{ marginTop: 10, display: "flex" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={styles.flexend_Grid}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleGoBack}
            variant="contained"
            id="goBackByLocation"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
